module.exports = __webpack_public_path__ + "fonts/HelveticaNeue-Light.40b2b616.woff";